import { Component, ElementRef } from '@angular/core';

@Component({ standalone: false, selector: 'ycn-report-link-component', templateUrl: './report-link.template.html' })
export class ReportLinkComponent {
    tooltipContent: string = '';

    url: string = '';

    name: string = '';

    constructor(private eltRef: ElementRef) {
        this.tooltipContent = this.eltRef.nativeElement.getAttribute('tooltipContent');
        this.url = this.eltRef.nativeElement.getAttribute('url');
        this.name = this.eltRef.nativeElement.getAttribute('name');
    }
}
